import AppRouter from './AppRouter';
import { Setup } from './misc/setup';
import { useEffect } from 'react';
import { env } from './lib/env';

function App() {
  useEffect(() => {
    if (window.jimo != null) {
      return;
    }

    const jimoProjectId = env('JIMO_PROJECT_ID');

    if (!jimoProjectId) {
      console.info('Jimo project ID not found, skipping initialization');
      return;
    }

    window.jimo = [];

    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = 'https://undercity.usejimo.com/jimo-invader.js';
    window['JIMO_PROJECT_ID'] = jimoProjectId;

    document.getElementsByTagName('head')[0].appendChild(s);
  }, []);

  return (
    <Setup>
      <AppRouter />
    </Setup>
  );
}

export default App;
